import { render, staticRenderFns } from "./ordonnance_add.vue?vue&type=template&id=49caf93d&scoped=true&"
import script from "./ordonnance_add.vue?vue&type=script&lang=js&"
export * from "./ordonnance_add.vue?vue&type=script&lang=js&"
import style0 from "./ordonnance_add.vue?vue&type=style&index=0&id=49caf93d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49caf93d",
  null
  
)

export default component.exports